/**
 * Static outer net on the websocket payload — the abuse bound, not the UX
 * one. The env-driven AP_AI_BUILDER_MAX_MESSAGE_LENGTH stays the friendly
 * limit (it answers with a translated message); these caps reject at schema
 * validation what no legitimate client ever sends.
 */
export const AI_BUILDER_PROMPT_HARD_CAP = 20_000
export const AI_BUILDER_CONTEXT_HARD_CAP = 200
